import { AppconfigService } from '../../services/shared/appconfig.service';
import { UtilityService } from '../../services/shared/utility.service';
import { Component, OnInit, ViewChild, ViewEncapsulation, NgZone, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import * as moment from 'moment';
import { from, Observable, Subscription } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { environment } from 'src/environments/environment';
//import { version } from 'package.json';


import { SimpleResponse } from '../../models/genericResponse.model';
import { AppConfig } from '../../models/appConfig.model';
import { ContactResponse, ContactDetails, CLPContactSOInvention } from '../../models/contact.model';
import { ContractSession, ContractSessionResponse, ContractSessionListResponse } from '../../models/contractsession.model';
import { State } from '../../models/state.model';
import { Message } from '../../models/message';
import { ContractNumResponse } from '../../models/contractNum.model';
import { UserResponse } from '../../models/user.model';

import { WizardService } from '../../services/wizard.service';
import { ContactService } from '../../services/contact.service';
import { ContractSessionService } from '../../services/contractsession.service';
import { StateService } from '../../services/state.service';
import { TransferDataService } from '../../services/shared/transferData.service';
import { ChatService } from '../../services/shared/chat.service';
import { NavigationService } from '../../services/navigation.service';
import { BillingService } from '../../services/billing.service';
import { isNullOrUndefined } from 'util';
import { ClientsStateDataService } from '../../services/clients-state-data.service';
import { UserService } from '../../services/user.service';

//For jquery
declare var $: any;

@Component({
    selector: 'app-nav-menu',
    templateUrl: './nav-menu.component.html',
    styleUrls: ['./nav-menu.component.css']
})
export class NavMenuComponent {
    public appVersion;
    clientConnection: number;
    desk = true;
    simpleResponse: SimpleResponse;
    item: boolean = false;
    encryptedUser: string = "";
    inventionId: number = 0;
    contactId: number = 0;
    contractSessionId: number = 0;
    clpUserId: number = 0;
    loginCLPUserId: number = 0;
    rdClpUserId: number = 0;
    mySOSite: string = '';
    inventHelpSite: string = '';
    backButtonSite: string = '';
    backToContact: string = '';
    clientState: string = ' ';
    otherCountry: string = ' ';
    clientCountry: any;
    isRemoteConnected: boolean = false;
    isSecondContract: boolean = false;
    isFileNumberModified: number = 0;
    bipFileNumber: number = 0;
    productId: number;
    clientConnected: string = '';
    currentUrl: any;
    stateList: State[];
    IsContractNumExist: boolean = false;
    uniqueID: string = new Date().getTime().toString();
    subscription: Subscription;
    contractNumber: number;
    refreshstate: any;
    fileNo: string;
    public messageForSibling: string;
    isPatentPlusUser: boolean = false;

    private contactResponse: ContactResponse;
    private contactDetails: ContactDetails;
    private soContactDetails: CLPContactSOInvention;
    private contractSession: ContractSession;
    private contractSessionListResponse: ContractSessionListResponse;
    private contractSessionResponse: ContractSessionResponse;
    message: Message;
    private contractNumResponse: ContractNumResponse;
    private userResponse: UserResponse;
    chkConnectionStatus: boolean = false;
    connectionStatus: number = 0;
    logoPath: string;
    constructor(private _appconfigService: AppconfigService,
        private _route: ActivatedRoute,
        private _contactService: ContactService,
        private _ngZone: NgZone,
        private _router: Router,
        private _utilityService: UtilityService,
        private _wizardService: WizardService,
        private _contractSessionService: ContractSessionService,
        private _stateService: StateService,
        public _transferDataService: TransferDataService,
        private _chatService: ChatService,
        private _navigationService: NavigationService,
        private _billingService: BillingService,
        private _snackBar: MatSnackBar,
        private _ClientsStateDataService: ClientsStateDataService,
        private _userService: UserService
    ) {
        this.fetchStateList();
        var current = this._router.url;
        this.appVersion = environment.appVersion;
        _router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                var currentUrl = event.url;
                if (currentUrl != null) {
                    var splitUrl = currentUrl.split('/', 3);
                    var contractSplitUrl = currentUrl.split('/', 7);
                    this.currentUrl = contractSplitUrl;
                }
                this.contactId = 0;
                this.isPatentPlusUser = ((contractSplitUrl.length > 3 && +contractSplitUrl[3].split('?')[0] == 1) || (contractSplitUrl.length > 6 && +contractSplitUrl[6].split('?')[0] == 1) || (splitUrl.length > 0 && splitUrl[1].startsWith("patent"))) ? true : false;
                //this.logoPath = this.isPatentPlusUser ? "assets/images/logo/Patent-Plus.png" : "assets/images/logo/logo_1226.png";
                this.logoPath = "assets/images/logo/logo_1226.png";

                if (splitUrl.length > 0 && (splitUrl[1] == "contract" || splitUrl[1] == "patent-plus-contract" || splitUrl[1].includes("contract-remote"))) {
                    this.contactId = + splitUrl[2];
                    this.loadContact();
                }
                if (contractSplitUrl.length > 0 && (contractSplitUrl[1] == "contract" || contractSplitUrl[1] == "patent-plus-contract" || contractSplitUrl[1].includes("contract-remote"))) {
                    this.contractSessionId = + contractSplitUrl[4];
                    this.rdClpUserId = +contractSplitUrl[5].split('?', 1);
                    this.loadClientState();
                }
            };
        });
        this.getMySoSite();
        this._route.queryParamMap.subscribe(params => {
            if (params.has('r')) {
                this.encryptedUser = params.get('r');
                this._userService.getAuthenticateR(this.encryptedUser)
                    .then(res => {
                        if (res) {
                            if (res.isvalid) {
                                this.userResponse = UtilityService.clone(res);
                                this.loginCLPUserId = this.userResponse.user.clpUserId;
                            }
                        }
                    })
                    .catch((err: HttpErrorResponse) => {
                        console.log("Client side Error : " + err);
                        this._utilityService.handleErrorResponse(err);
                    });
            }
        });
        this.subscribeToEvents();
    }

    ngOnInit() {
        this.loadMessage();
        this.refresh();
        this.refreshConnStatus();
    }

    ngAfterViewInit() {
        //this.chkSubscribeMessageRcvd();
        //this._chatService.registerOnServerEvents();
    }

    chkSubscribeMessageRcvd() {
        setTimeout(() => {
            if (this.chkConnectionStatus == false) {
                //this.chkConnectionStatus = true;
            } else
                this.chkSubscribeMessageRcvd();
        }, 1000);
    }

    refreshConnStatus() {
        setTimeout(() => {
            this.connectionStatus = this._transferDataService.connectionStatus;
            if (this.connectionStatus == 1 || this.connectionStatus == 3)
                this.clientConnected = "Connected";
            else if (this.connectionStatus == 2)
                this.clientConnected = "Paused";
            else
                this.clientConnected = "NotConnected";
            this.refreshConnStatus();
        }, 1000);
    }

    //connectionStatus
    private subscribeToEvents(): void {

        // console.log("Nav subscribe");
        //this.subscription = this._chatService.messageReceived.subscribe((message: Message) => {
        ////this._chatService.messageReceived.subscribe((message: Message) => {
        //  this._ngZone.run(() => {
        //    //let message = this.message;
        //    if (message.contractSessionId !== this.contractSessionId) {
        //      this.message = UtilityService.clone(message);
        //      console.log("Nav subscribe", this.message);
        //    }
        //  });
        //});

        //this._chatService.reconnecting.subscribe((data: string) => {
        //  this._ngZone.run(() => {
        //    console.log('reconnecting', data);
        //  });
        //});

        //this._chatService.reconnected.subscribe((data: string) => {
        //  this._ngZone.run(() => {
        //    console.log(data);
        //    this._chatService.startConnection();
        //    console.log('reconnected', data);
        //  });
        //});
    }

    private async loadMessage() {
        await this._navigationService.getSignalRMessageAsync(this.encryptedUser)
            .then(res => {
                if (res) {
                    this.message = UtilityService.clone(res);
                    this._transferDataService.message = this.message;
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
    }

    private async loadFileNumber() {
        await this._billingService.getFileNoByUserIdAsync(this.encryptedUser, this.clpUserId, this.contractSessionId)
            .then(res => {
                if (res) {
                    this.contractNumResponse = UtilityService.clone(res);
                    this.contractNumber = this.contractNumResponse.contractNumDetails.contractNumber;
                    $("#fileNumber").val(this.contractNumber == 0 ? '' : this.contractNumber);
                    this._transferDataService.fileNumber = $("#fileNumber").val();
                    this._transferDataService.isNavAction = true;
                    this._transferDataService.message.isClient = false;
                    this._transferDataService.message.isSalesRep = true;
                    this._transferDataService.message.clientuniqueid = this.uniqueID;
                    this._transferDataService.message.isCustAction = false;
                    this._transferDataService.message.billingDetails.fileNumber = $("#fileNumber").val();
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
    }
    async loadContact() {
        if (isNullOrUndefined(this.contactId)) {
            this._route.paramMap.subscribe(async params => {
                if (params.has('contact')) {
                    this.contactId = + params.get('contact');
                }
            });
        }
        await this._contactService.getContactAsync(this.encryptedUser, this.contactId)
            .then(async (result: ContactResponse) => {
                if (result) {
                    if (result.statusCode == 0) {

                        this.contactResponse = UtilityService.clone(result);
                        if (this.contactResponse) {
                            this.contactDetails = UtilityService.clone(this.contactResponse.contactDetails);
                            this.backToContact = this.contactDetails.lastname;
                            if (this.contractSessionId > 0 && !isNullOrUndefined(this.contractSessionId)) {
                                await this._contractSessionService.getContactSessionByCSIdAsync(this.encryptedUser, this.contractSessionId)
                                    .then(res => {
                                        if (res) {
                                            this.contractSession = UtilityService.clone(res);
                                            this.clpUserId = this.contractSession.CLPUserId;
                                            this.isSecondContract = this.contractSession.IsSecondContract;
                                            this.isFileNumberModified = this.contractSession.isFileNumberModified;
                                            this.bipFileNumber = this.contractSession.bipFileNumber;
                                            this.loadFileNumber();
                                        }
                                    })
                                    .catch((err: HttpErrorResponse) => {
                                        this._utilityService.handleErrorResponse(err);
                                    });
                            }
                        }
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });

    }

    private async fetchStateList() {
        await this._stateService.getStateList(this.encryptedUser)
            .then(async (result: State[]) => {
                this.stateList = UtilityService.clone(result);
            })
            .catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
    }

    loadClientState() {
        if (this.contractSessionId > 0 && !isNullOrUndefined(this.contractSessionId)) {
            this._contractSessionService.getContactSessionByCSIdAsync(this.encryptedUser, this.contractSessionId)
                .then(res => {
                    if (res) {
                        this.contractSession = UtilityService.clone(res);
                        if (this.contactDetails) {
                            var clientState = this.contractSession.clientState;
                            if (this.contractSession.CountryID == 1 || this.contractSession.CountryID == 399) {
                                if (this.stateList) {
                                    this.filterUserStateList(clientState).then(async res => {
                                        if (res.length > 0) {
                                            this.clientState = res[0].name.substr(0, 20);
                                        }
                                        if (this.contractSession.CountryID == 399) {
                                            if (clientState.length > 10)
                                                this.clientState = clientState.substr(0, 7) + "...";
                                            else
                                                this.clientState = clientState.substr(0, 10);
                                            if (this.contactDetails.country.length > 10)
                                                this.otherCountry = this.contactDetails.country.substr(0, 7) + "...";
                                            else
                                                this.otherCountry = this.contactDetails.country.substr(0, 10);
                                        }
                                        //else {
                                        //    this.clientState = this.contactDetails.state;
                                        //}
                                    });
                                }
                            }
                            else
                                this.clientState = "";
                            this.clientCountry = this.contractSession.CountryID;
                            //if (this.message) {
                            //  if (this.message.connectionStatus == 1 || this.message.connectionStatus == 2 || this.message.connectionStatus == 3)
                            //    this.clientConnected = "Client is connected";
                            //  else
                            //    this.clientConnected = "Client is not connected";
                            //}

                            //if (this.clientCountry == 0 || this.clientCountry == 1) {
                            //    this.clientCountry = this.contactDetails.country;
                            //}
                        }
                    }
                }).then(r => { })
                .catch((err: HttpErrorResponse) => {
                    this._utilityService.handleErrorResponse(err);
                });
        }
    }

    //clientSessionEnd() {
    //  this._transferDataService.isClientConnect == false
    //}

    refresh() {
        this.refreshstate = setTimeout(() => {
            this.subscription = this._ClientsStateDataService.getMessage().subscribe(msg => this.messageForSibling = msg);
            //console.log("this tis suscription:" + this.messageForSibling);
            if (this.messageForSibling == "United Kingdom" && this.clientState == "")
                this.messageForSibling = "United Kingdom";
            else if (this.messageForSibling == "Ireland" && this.clientState == "")
                this.messageForSibling = "Ireland";
            else if (this.messageForSibling == "Australia" && this.clientState == "")
                this.messageForSibling = "Australia";
            else if (this.messageForSibling == "Canada" && this.clientState == "")
                this.messageForSibling = "Canada";
            else if (this.messageForSibling === this.clientState)
                this.messageForSibling = this.clientState;
            else
                this.loadClientState();
            this.refresh();
        }, 1000);
    }

    ngOnDestroy() {
        this.subscription.unsubscribe(); // onDestroy cancels the subscribe request
        clearTimeout(this.refreshstate);
    }

    NextStatus() {
        //this._chatService.nextConnectionState();
        //this._chatService.clientConnection == 2 ? this.isRemoteConnected = true : this.isRemoteConnected = false;
    }


    refreshClientState() {
        //setTimeout(() => {
        //  this._transferDataService.isClientConnect == true ? this.isRemoteConnected = true : this.isRemoteConnected = false;
        //  this.refreshClientState();
        //}, 1000);
    }

    private async filterUserStateList(istateCode: string): Promise<State[]> {
        const filteredRecords: State[] = this.stateList.filter(st => st.code == istateCode);
        return await UtilityService.clone(filteredRecords);
    }

    loadNavigationMenu() {
        this._route.paramMap.subscribe(async params => {
            if (params.has('contact')) {
                this.contactId = + params.get('contact');
            }
            if (params.has('invention')) {
                if (!this.inventionId)
                    this.inventionId = +params.get('invention');
            }
            if (params.has('contractSessionId')) {
                this.contractSessionId = +params.get('contractSessionId');
            }
        });
    }

    getMySoSite() {
        this._wizardService.getSiteAsync(this.encryptedUser)
            .then(res => {
                if (res)
                    this.simpleResponse = UtilityService.clone(res);
                if (this.simpleResponse) {
                    this.mySOSite = this.simpleResponse.messageString;
                    this.getInventHelpSite();
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
    }

    getInventHelpSite() {
        this._wizardService.getEvolveCSSiteURLAsync(this.encryptedUser)
            .then(res => {
                if (res)
                    this.simpleResponse = UtilityService.clone(res);

                if (this.simpleResponse) {
                    this.inventHelpSite = this.simpleResponse.messageString;
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
    }

    clickOnBack() {
        if (this.mySOSite && this.contactId)
            this.backButtonSite = this.mySOSite + '/contact/view.aspx?cid=' + this.contactId;
        window.open(this.backButtonSite, '_blank');
    }

    clickBackContractList() {
        this._router.navigate([this.currentUrl[1].startsWith('patent') ? '/patent-plus-contract-list' : '/contract-list', this.rdClpUserId > 0 ? this.rdClpUserId : this.clpUserId, this.rdClpUserId > 0 ? 0 : this.contactId], {
            queryParams: { 'c': this.rdClpUserId > 0 ? 0 : this.contactId, 'us': this.rdClpUserId > 0 ? this.rdClpUserId : this.clpUserId, 'r': this.encryptedUser }
        });
        this.stopConnection();
    }

    stopConnection() {
        this._transferDataService.connectionStatus = 0;
        this._transferDataService.isNavAction = true;
        this._transferDataService.message.connectionStatus = 0;
        this._transferDataService.message.docTypeId = -999;
        this._transferDataService.message.isClient = false;
        this._transferDataService.message.isSalesRep = true;
        this._transferDataService.message.clientuniqueid = this.uniqueID;
        this._transferDataService.message.isCustAction = false;
        this._chatService.sendMessage(this._transferDataService.message);
    }
    pauseConnection() {
        this._transferDataService.connectionStatus = 2;
        this._transferDataService.isNavAction = true;
        this._transferDataService.message.connectionStatus = 2;
        this._transferDataService.message.isClient = false;
        this._transferDataService.message.isSalesRep = true;
        this._transferDataService.message.clientuniqueid = this.uniqueID;
        this._transferDataService.message.isCustAction = false;
    }

    resumeConnection() {
        this._transferDataService.connectionStatus = 3;
        this._transferDataService.isNavAction = true;
        this._transferDataService.message.connectionStatus = 3;
        this._transferDataService.message.isClient = false;
        this._transferDataService.message.isSalesRep = true;
        this._transferDataService.message.clientuniqueid = this.uniqueID;
        this._transferDataService.message.isCustAction = false;
    }

    async getFileNumber() {
        if ((parseInt($("#fileNumber").val()) == 0) || !$("#fileNumber").val()) {
            this._transferDataService.isFileNoBlank = true;
            this.openSnackBar("File Number can not be 0.", "");
        }
        else
            this.getDuplicateFileNumber();
        this._transferDataService.isNavAction = true;
        this._transferDataService.message.isClient = false;
        this._transferDataService.message.isSalesRep = true;
        this._transferDataService.message.clientuniqueid = this.uniqueID;
        this._transferDataService.message.isCustAction = false;
        this._transferDataService.message.docTypeId = -999;
    }

    refreshFileNumber() {
        this._transferDataService.fileNumber = $("#fileNumber").val();
        this._transferDataService.isChangedFileNumber = false;
    }

    updateFileNumber() {
        this._contractSessionService.getContactSessionByCSIdAsync(this.encryptedUser, this.contractSessionId)
            .then(res => {
                if (res) {
                    this.contractSession = UtilityService.clone(res);
                    this.isSecondContract = this.contractSession.IsSecondContract;
                    if ((parseInt($("#fileNumber").val()) == 0) || !$("#fileNumber").val()) {
                        this._transferDataService.isFileNoBlank = true;
                        this.openSnackBar("File Number can not be 0.", "");
                    }
                    else if (this.isSecondContract && (this.bipFileNumber > 0 && this.bipFileNumber != +$("#fileNumber").val()))
                        $('#modalUpdateFileNumber').modal('show');
                    else
                        this.getDuplicateFileNumber("userUpdate");
                }
            }).then(r => { })
            .catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
    }

    assignedDuplicateFileNo(response: string) {
        if (response == 'Yes') {
            this.contractNumberUpdate();
        }
        else
            $("#fileNumber").val(this.contractNumber == 0 ? '' : this.contractNumber);
        $('#modalUpdateFileNumber').modal('hide');
    }

    getDuplicateFileNumber(source?: string) {
        this._billingService.getDuplicateFileNoAsync(this.encryptedUser, this.clpUserId, parseInt($("#fileNumber").val()))
            .then(async (result: boolean) => {
                this.IsContractNumExist = UtilityService.clone(result);
                if (source == "userUpdate") {
                    if (this.IsContractNumExist && !this.isSecondContract) {
                        $('#modalUpdateFileNumber').modal('show');
                        $("#fileNumber").val(this.contractNumber == 0 ? '' : this.contractNumber);
                        this._snackBar.dismiss();
                    }
                    else {
                        this._transferDataService.fileNumber = $("#fileNumber").val();
                        this.contractNumberUpdate();
                    }
                }
                if (this._transferDataService.fileNumber)
                    this._transferDataService.message.billingDetails.fileNumber = $("#fileNumber").val();
                this._transferDataService.isFileNoBlank = false;
            })
            .catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
    }

    contractNumberUpdate() {
        this._billingService.contractNumberUpdateAsync(this.encryptedUser, this.contractSessionId, $("#fileNumber").val(), this.loginCLPUserId)
            .then(contractNumber => {
                if (contractNumber) {
                    this.copyContactDetailsToDataObject(contractNumber);
                    this.openSnackBar("File# " + $("#fileNumber").val() + " has been assigned to this contract.", "");
                    this.updateContactInSalesOptima();
                    this._transferDataService.isChangedFileNumber = true;
                    this._transferDataService.isNavAction = true;
                    this._transferDataService.message.isClient = false;
                    this._transferDataService.message.isSalesRep = true;
                    this._transferDataService.message.clientuniqueid = this.uniqueID;
                    this._transferDataService.message.isCustAction = false;
                    this.loadFileNumber();
                }
                else {
                    this._transferDataService.isChangedFileNumber = false;
                    this.openSnackBar("Failure while updating File number. Please try again or contact administrator.", "");
                }
            }).catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
    }

    updateContactInSalesOptima() {
        this._contactService.updateContactInSalesOptimaAsync(this.encryptedUser, this.soContactDetails)
            .then(res => {
                this._contactService.getContactAsync(this.encryptedUser, this.contactId)
                    .then(async (result: ContactResponse) => {
                        if (result) {
                            if (result.statusCode != 0) {
                                console.log("updateContactInSalesOptima result status code: " + result.statusCode);
                            }
                        }
                    })
                    .catch((err: HttpErrorResponse) => {
                        this._utilityService.handleErrorResponse(err);
                    });
            })
            .catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
    }

    copyContactDetailsToDataObject(contractNumber: string) {
        if (isNullOrUndefined(this.contactId)) {
            this._route.paramMap.subscribe(async params => {
                if (params.has('contact')) {
                    this.contactId = + params.get('contact');
                }
            });
        }
        let clpContactDetails = {} as CLPContactSOInvention;
        clpContactDetails.contactId = this.contactId;
        clpContactDetails.fileNumber = $("#fileNumber").val();
        clpContactDetails.contractNumber = contractNumber;
        this.soContactDetails = clpContactDetails;
    }

    allowNumeric(e) {
        if (e.ctrlKey || e.altKey) {
            e.preventDefault();
        } else {
            var key = e.keyCode;
            if (key != 8 && key != 0 && (key < 48 || key > 57)) {
                e.preventDefault();
            }
        }
    }
    openSnackBar(message: string, action: string) {
        this._snackBar.open(message, action, {
            verticalPosition: 'top',
            horizontalPosition: 'right',
            duration: 5000,
        });
    }

}
